export default {
  data() {
    return {
      selectedLanguage: null
    }
  },
  methods: {
    onSelectedLanguageChange(selectedLanguage) {
      this.selectedLanguage = selectedLanguage
    },
    getQrCodeSrc() {
      if (this.entity.qr_code_image) {
        return Promise.resolve(this.entity.qr_code_image);
      } else if (this.entity.qr_code_url) {
        return Promise.resolve(this.entity.qr_code_url);
      } else if (this.entity.qr_code_text) {
        return this.entityService.getQRCode({
          text: this.entity.qr_code_text,
          image: this.entity.qr_code_image,
          url: this.entity.qr_code_url
        });
      }
    },
    getPreviewData: async function () {
      const lang = this.selectedLanguage || Object.keys(this.entity.body)[0]
      return {
        subject: this.entity.subject[lang],
        body: this.entity.body[lang],
        type: this.entity.label[lang],
        qr_code_src: await this.getQrCodeSrc(),
        image: this.entity.image_url,
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/views/advertisingBanner/mixins/advertisingBannerDetail.js